import { MDXLayout as Layout } from "@/shared/components/MDX/MDXLayout";
import { Alert } from "@/shared/components/MDX/MDXComponents";

# راهنمای فراخوانی پالت (Recall)

در این فرم می‌توانید با انتخاب یک پالت (Lot)، تمام محصولات و قطعات سریال‌داری که از مواد آن پالت در ساختشان استفاده شده است را پیدا کنید (جهت فراخوانی یا Recall).

## ۱. انتخاب پالت
از لیست کشویی **پالت (InventoryLot)**، پالت مشکوک یا معیوب را انتخاب کنید و دکمه جست‌وجو را بزنید.

## ۲. لیست محصولات متأثر
سیستم بلافاصله لیست تمامی شماره سریال‌هایی که به صورت مستقیم یا غیرمستقیم (از طریق نیمه‌ساخته‌ها) از این پالت تغذیه شده‌اند را نمایش می‌دهد.

## ۳. دسترسی به ردیابی
با کلیک روی دکمه **مشاهدهٔ ردیابی** در مقابل هر سریال، مستقیماً به صفحه تاریخچه آن سریال منتقل می‌شوید تا جزئیات بیشتری را بررسی کنید.

export default Layout;
